export const RadioWidget = () => `
    <div id="inline-radio-widget" class="inline-radio-wrapper">
        <div class="inline-radio-content">
            <button id="inline-radio-play-btn" class="inline-radio-play-btn">
                <span class="icon">▶&#xFE0E;</span>
            </button>
            <div class="inline-radio-meta">
                <span id="inline-radio-subtitle" class="inline-radio-subtitle">GADDAR RADYO</span>
                <div class="radio-eq" id="radio-eq" style="display:none;">
                    <span></span><span></span><span></span><span></span>
                </div>
            </div>
            <div class="inline-radio-vol-trigger" id="inline-radio-vol-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>
            </div>
        </div>
        <div class="inline-radio-volume-row" id="inline-radio-volume-row" style="display:none;">
            <input type="range" id="inline-radio-volume" class="inline-radio-volume-slider" min="0" max="1" step="0.01" value="0.7">
        </div>
    </div>
`;

window.InlineRadioManager = {
    playBtn: null,
    subtitleEl: null,
    volumeSlider: null,
    volumeRow: null,
    volIcon: null,
    eqEl: null,
    audioElement: null,
    isPlaying: false,

    init: function() {
        this.playBtn = document.getElementById('inline-radio-play-btn');
        this.subtitleEl = document.getElementById('inline-radio-subtitle');
        this.volumeSlider = document.getElementById('inline-radio-volume');
        this.volumeRow = document.getElementById('inline-radio-volume-row');
        this.volIcon = document.getElementById('inline-radio-vol-icon');
        this.eqEl = document.getElementById('radio-eq');

        if (!this.playBtn) return;

        this.playBtn.addEventListener('click', () => this.togglePlay());
        
        if (this.volIcon) {
            this.volIcon.addEventListener('click', () => {
                if(this.volumeRow.style.display === 'none') {
                    this.volumeRow.style.display = 'block';
                } else {
                    this.volumeRow.style.display = 'none';
                }
            });
        }

        if (this.volumeSlider) {
            this.volumeSlider.addEventListener('input', (e) => {
                const val = parseFloat(e.target.value);
                if (this.audioElement) {
                    this.audioElement.volume = val;
                }
                if (this.volIcon) {
                    if (val === 0) this.volIcon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
                    else if (val < 0.5) this.volIcon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>';
                    else this.volIcon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>';
                }
            });
        }
    },

    togglePlay: async function() {
        const wrapper = document.getElementById('inline-radio-widget');

        if (!this.isPlaying) {
            try {
                this.playBtn.classList.add('loading');
                const res = await fetch('/api/nowplaying');
                if (!res.ok) throw new Error("API Error");
                const data = await res.json();
                
                if (!data || data.length === 0 || !data[0].station || !data[0].station.listen_url) {
                    this.playBtn.classList.remove('loading');
                    alert("Şu an aktif bir yayın bulunmuyor.");
                    return;
                }
                
                const listenUrl = data[0].station.listen_url;
                
                if (!this.audioElement) {
                    this.audioElement = new Audio();
                }
                
                this.audioElement.src = listenUrl + "?t=" + new Date().getTime();
                this.audioElement.volume = this.volumeSlider ? parseFloat(this.volumeSlider.value) : 0.7;
                
                await this.audioElement.play();
                this.playBtn.classList.remove('loading');

                this.isPlaying = true;
                this.playBtn.innerHTML = '<span class="icon">■</span>';
                if (wrapper) wrapper.classList.add('playing');
                if (this.eqEl) this.eqEl.style.display = 'flex';
                
                if (data[0].live && data[0].live.is_live) {
                    this.subtitleEl.textContent = "🎙️ CANLI YAYIN";
                    this.subtitleEl.style.color = "#ff4d4f";
                } else {
                    this.subtitleEl.textContent = "GADDAR RADYO";
                    this.subtitleEl.style.color = "";
                }

            } catch (e) {
                this.playBtn.classList.remove('loading');
                console.error("Radyo bağlantı hatası:", e);
                alert("Radyo sunucusuna bağlanılamadı.");
            }
        } else {
            this.isPlaying = false;
            if (this.audioElement) {
                this.audioElement.pause();
                this.audioElement.src = '';
            }
            this.playBtn.innerHTML = '<span class="icon">▶&#xFE0E;</span>';
            if (wrapper) wrapper.classList.remove('playing');
            if (this.eqEl) this.eqEl.style.display = 'none';
        }
    }
};
